import { memo } from 'react';
import { MenuItem as MuiMenuItem, Checkbox } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CheckIcon from '@mui/icons-material/Check';
import { useIsMobile } from '@client/hooks/dom.hooks';
import type { MenuItemProps as MuiMenuItemProps } from '@mui/material';

const useStyles = makeStyles({ name: 'MultipleSelectMenuItem' })((theme) => ({
  menuItem: {
    color: theme.palette.text.primary,
  },
  checkIcon: {
    marginTop: '0px !important',
  },
}));

interface MenuItemProps {
  readonly checkbox?: boolean;
}

export const MenuItem = memo<MenuItemProps & MuiMenuItemProps>(({
  children, checkbox = false, selected = false, ...props
}) => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <option value={props.value || props['data-value']}>
        {children}
      </option>
    );
  }

  if (!checkbox) {
    return (
      <MuiMenuItem
        className={classes.menuItem}
        selected={selected}
        {...props}
      >
        {children}
      </MuiMenuItem>
    );
  }

  return (
    <MuiMenuItem
      className={classes.menuItem}
      selected={selected}
      {...props}
    >
      <Checkbox
        checked={selected}
        checkedIcon={<CheckIcon className={classes.checkIcon} />}
      />

      <span>
        {children}
      </span>
    </MuiMenuItem>
  );
});
